// import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../../views/HomeView.vue'
import OverLow from '../../views/overLow/largeScreen.vue'
import { createModule } from '@/router/type'
export default createModule([
  {
    path: '/home',
    name: 'home',
    redirect: '/middleware',
    component: HomeView,
    children:[
      // login
      {
        path:'/loginlog',
        name:"loginlog",

        component:() => import('@/views/login/loginlog.vue')
      },
      {
        path:'/operate',
        name:"operate",

        component:() => import('@/views/login/operate.vue')
      },
      {
        path:'/devicelog',
        name:"devicelog",

        component:() => import('@/views/login/devicelog.vue')
      },
      {
        path:'/userInfo',
        name:'userInfo',
        component:() => import('@/views/login/userInfo.vue')
      },
      // system
      {
        path:'/user',
        name:"user",

        component:() => import('@/views/system/user.vue')
      },
      {
        path:'/limits',
        name:"limits",

        component:() => import('@/views/system/limits.vue')
      },
      {
        path:'/area',
        name:"area",

        component:() => import('@/views/system/area.vue')
      },
      //device management.vue
      {
        path:'/management',
        name:"management",
        component:() => import('@/views/devicemanagement/management.vue')
      },
      {
        path:'/lookover',
        name:"lookover",
        props:true,
        meta:{activeMenu:'/management'},
        component:() => import('@/views/devicemanagement/lookover.vue')
      },
      {
        path:'/newequipment/',
        name:"neweqipment",
        meta:{activeMenu: '/management'},
        component:() => import('@/views/devicemanagement/NewEquipment.vue')
      },
      {
        path:'/lookVarTemp/',
        name:"lookVarTemp",
        meta:{activeMenu:'/VariableTemplate'},
        component:() => import('@/views/devicemanagement/lookVarTemp.vue')
      },

      {
        path:'/VariableTemplate',
        name:"VariableTemplate",
        component:() => import('@/views/devicemanagement/VariableTemplate.vue')
      },
      {
        path:'/gatewayAdministration',
        name:"gatewayAdministration",
        component:() => import('@/views/devicemanagement/gatewayAdministration.vue')
      },
      {
        path:'/addtemplate/',
        name:"AddTemplate",
        meta:{activeMenu: '/VariableTemplate'},
        component:() => import('@/views/devicemanagement/AddTemplate.vue')
      },
      {
        path:'/batchAddDevice/',
        name:"batchAddDevice",
        component:() => import('@/views/devicemanagement/batchAddDevice.vue')
      },
      //   监控
      {
        path:'/cameraManage',
        name:"cameraManage",
        component:() => import('@/views/video/cameraManage.vue')
      },
      {
        path:'/cameraView',
        name:"cameraView",
        component:() => import('@/views/video/camerView.vue')
      },
      //     维修任务
      {
        path:'/manage',
        name:"manage",
        component:() => import('@/views/maintenance/manage.vue')
      },
      {
        path:'/maAnalysis',
        name:"maAnalysis",
        component:() => import('@/views/maintenance/analysis.vue')
      },
      {
        path:'/task',
        name:"task",
        component:() => import('@/views/maintenance/task.vue')
      },
      {
        path:'/LookSniversalVariable',
        name:"LookSniversalVariable",
        meta:{activeMenu: '/task'},
        component:() => import('@/views/maintenance/LookSniversalVariable.vue')
      },
      //  巡检任务
      {
        path:'/tasks',
        name:"tasks",
        component:() => import('@/views/InspectionTasks/tasks.vue')
      },
      {
        path:'/lookTasks/',
        name:"lookTasks",
        meta: { activeMenu: '/tasks' },
        component:() => import('@/views/InspectionTasks/lookTasks.vue')
      },
      {
        path:'/analysis',
        name:"analysis",
        component:() => import('@/views/InspectionTasks/analysis.vue')
      },
      {
        path:'/inspectionItem',
        name:"inspectionItem",
        component:() => import('@/views/InspectionTasks/InspectionItem.vue')
      },
      {
        path:'/inspector/',
        name:"inspector",
        component:() => import('@/views/InspectionTasks/Inspector.vue')
      },
      {
        path:'/scheme',
        name:"scheme",
        component:() => import('@/views/InspectionTasks/scheme.vue')
      },
      {
        path:'/patrolScheme',
        name:"patrolScheme",
        meta:{activeMenu:'/scheme' },
        component:() => import('@/views/InspectionTasks/patrolScheme.vue')
      },
      //     报警
      {
        path:'/analyse',
        name:"analyse",
        component:() => import('@/views/alarm/analyse.vue')
      },
      {
        path:'/alarmdata',
        name:"alarmdata",
        component:() => import('@/views/alarm/data.vue')
      },
      {
        path:'/trigger',
        name:"trigger",
        component:() => import('@/views/alarm/trigger.vue')
      },
      {
        path:'/push',
        name:"push",
        component:() => import('@/views/alarm/push.vue')
      },
      //   数据报表
      {
        path:'/opertion',
        name:"opertion",
        component:() => import('@/views/dataReport/operation.vue')
      },
      {
        path:'/deviceData',
        name:"deviceData",
        component:() => import('@/views/dataReport/deviceData.vue')
      },

    ],
  },
  {
    path: '/overLow',
    name: 'overLow',
    component:OverLow,
    children:[
      //大屏
      {
        path:'/data',
        name:"data",
        component:() => import('@/views/overLow/data.vue')
      },
      {
        path:'/device',
        name:"device",
        component:() => import('@/views/overLow/device.vue')
      },
      {
        path:'/operationAndMaintenance',
        name:"operationAndMaintenance",
        component:() => import('@/views/overLow/operationAndMaintenance.vue')
      }
    ]

  }
], true)


